
import Vue from 'vue';

export default Vue.extend({
  props: {
    category: {
      type: String,
      default: 'Referenzen',
    },
    date: {
      type: Object,
      default: () => ({
        dateValue: '03.09.2022',
      }),
    },
    text: {
      type: null as any,
      default: 'News',
    },
    image: {
      type: Object,
    },
    link: {
      type: Object,
      default: () => ({
        url: '/',
      }),
    },
    subtags: {
      type: Array,
      default: () => [],
    },
    // Used for a11y adjustments
    disableLinks: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getSubTags(): string {
      return this.subtags.join(' · ');
    },
  },
});
